export default __webpack_public_path__ + "static/Candi.Allphin_social-de51574f70a5944686f87621e6fe68aa.jpg";